import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder} from "@angular/forms";
import {EncryptDecryptService} from "../services/encrypt-decrypt.service";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-edit-reponse-pj',
  templateUrl: './edit-reponse-pj.component.html',
  styleUrls: ['./edit-reponse-pj.component.css']
})
export class EditReponsePjComponent implements OnInit {

  apikey: string;
  user: any;
  constructor(private _snackBar: MatSnackBar, public dialogRef: MatDialogRef<EditReponsePjComponent>, private encdec: EncryptDecryptService, private http: HttpClient, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.apikey = localStorage.getItem('apikey');
    this.user = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit(): void {
  }

  handleUpload(event) {
    var files = event.target.files;
    var file = files[0];

    if (files && file) {
      var reader = new FileReader();

      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsArrayBuffer(file);
      //console.log(reader.result);
    }
    //console.log(this.base64textString);
  }

  handleUploadCL(event) {
    var files = event.target.files;
    var file = files[0];

    if (files && file) {
      var reader = new FileReader();

      reader.onload =this._handleReaderLoadedCL.bind(this);
      reader.readAsArrayBuffer(file);
      //console.log(reader.result);
    }
    //console.log(this.base64textString);
  }

  _arrayBufferToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    //console.log("Byte Array : " + bytes)
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode( bytes[ i ] );
    }
    return btoa(binary);
  }

  _handleReaderLoadedCL(readerEvt) {
    var buffer = readerEvt.target.result;
    //var uint8 = new Uint8Array(binaryString);
    //var result = Array.from(uint8);

    var bs4String = this._arrayBufferToBase64( buffer );
    //console.log("Base64: " + bs4String);
    let objProfil: profil = {
      profil_pj1: "",
      profil_pj2: bs4String,
      profil_pj1_nom: "",
      profil_pj2_nom: ""
    }

    let obj: PieceJointe = {
      idcandidat: this.user.idcandidat,
      profil: objProfil
    };


    let data = this.encdec.getEncrypt( JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);

    this.http.post('https://api2.sitederecrutement.com/Home/updatecandidate?apikey='+ this.apikey, formData, { responseType: "text" }).subscribe(
      (result) => {
        this._snackBar.open("Votre pièce jointe a bien été enregistrée", 'Fermer', {
          duration: 5 * 1000,
        })
      }
    );
    //console.log(btoa(binaryString));
  }

  _handleReaderLoaded(readerEvt) {
    var buffer = readerEvt.target.result;
    //var uint8 = new Uint8Array(binaryString);
    //var result = Array.from(uint8);

    var bs4String = this._arrayBufferToBase64( buffer );
    //console.log("Base64: " + bs4String);
    let objProfil: profil = {
      profil_pj1: bs4String,
      profil_pj2: "",
      profil_pj1_nom: "",
      profil_pj2_nom: ""
    }

    let obj: PieceJointe = {
      idcandidat: this.user.idcandidat,
      profil: objProfil
    };


    let data = this.encdec.getEncrypt( JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);

    this.http.post('https://api2.sitederecrutement.com/Home/updatecandidate?apikey='+ this.apikey, formData, { responseType: "text" }).subscribe(
      (result) => {
        this._snackBar.open("Votre pièce jointe a bien été enregistrée", 'Fermer', {
          duration: 5 * 1000,
        })
      }
    );
    //console.log(btoa(binaryString));
  }

}

interface profil{
  profil_pj1: any;
  profil_pj2: any;
  profil_pj1_nom: any;
  profil_pj2_nom: any;
}

interface PieceJointe {
  idcandidat: string;
  profil: profil;
}
